import * as React from 'react';
import { observer } from 'mobx-react';
import { Accordion, LabelSlide } from 'elc-accordion';
import { Body2, Heading5, Body1 } from 'elc-typography';
import { ContentSpacing } from 'elc-base-theme';
import styled from 'styled-components';
import { Row } from 'elc-grid';
import { classes } from '../../utils/Classes';

export interface IProductUsageFieldProps {
    useAccordion?: boolean;
    usageField: string;
    className?: string;
    usageFieldAccordionLabel: string;
}

const StyledAccordion = styled(Accordion)`
    margin-bottom: ${ContentSpacing.space16};
`;

const StyledRow = styled(Row)`
    display: flex;
    flex-direction: column;
    margin-bottom: ${ContentSpacing.space16};
`;

const StyledHeading = styled(Heading5)`
    margin-bottom: ${ContentSpacing.space8};
`;

export const ProductUsageField = observer((props: IProductUsageFieldProps) => {
    const { useAccordion, usageField, className } = props;
    const usageFieldAccordionLabel = props.usageFieldAccordionLabel.toLowerCase();
    const productUsageFieldClassNames = classes(`product-${className}`);
    const productOverviewAccordionClassNames = classes('product-full-accordion');

    return (
        <div className={productUsageFieldClassNames}>
            {useAccordion && usageFieldAccordionLabel ? (
                <StyledAccordion className={productOverviewAccordionClassNames}>
                    <LabelSlide id={usageFieldAccordionLabel} title={usageFieldAccordionLabel}>
                        <Body2 dangerouslySetInnerHTML={{ __html: usageField }} />
                    </LabelSlide>
                </StyledAccordion>
            ) : (
                <StyledRow className={productUsageFieldClassNames}>
                    <StyledHeading>{usageFieldAccordionLabel}</StyledHeading>
                    <Body1 dangerouslySetInnerHTML={{ __html: usageField }} />
                </StyledRow>
            )}
        </div>
    );
});
